import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { BaseComponent } from '@macs-frontend/core';
import { State } from '@macs-frontend/reducers';
import { Store } from '@ngrx/store';
import { ProjectStatuses } from '../../models/project';
import { StringUtils } from '@macs-frontend/features/shared/utils/string';

export enum ColorClasses {
  GREEN = 'dropdown__item-signal_green',
  DEFAULT = 'dropdown__item-signal_default',
  ORANGE = 'dropdown__item-signal_orange',
  BLUE = 'dropdown__item-signal_blue',
  GRAY = 'dropdown__item-signal_gray',
  EMPTY = 'dropdown__item-signal_empty',
}

export enum AvailableLabelsWithColoredFilter {
  Projects = 'Projects',
}

@Component({
  selector: 'md-status-filter',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './status-filter.component.html',
})
export class StatusFilterComponent extends BaseComponent {
  @Output() filter: EventEmitter<string> = new EventEmitter();
  @Output() filterMultiple: EventEmitter<string[]> = new EventEmitter();
  // @ts-expect-error
  @Input() currentStatus: string;
  @Input() currentStatuses: string[] = [];
  @Input() total?: null | number;
  // @ts-expect-error
  @Input() label: string;
  // @ts-expect-error
  @Input() statusesArray: string[];
  @Input() showTotal = true;
  @Input() multipleSelect = false;
  // @ts-expect-error
  @Input() statusLabelsArray: { [key: string]: string };

  // @ts-expect-error
  showItems: boolean;
  statusColors = {
    [ProjectStatuses.ACTIVE]: ColorClasses.GREEN,
    [ProjectStatuses.ALL]: ColorClasses.DEFAULT,
    [ProjectStatuses.ARCHIVED]: ColorClasses.GRAY,
    [ProjectStatuses.DRAFT]: ColorClasses.BLUE,
    [ProjectStatuses.FAVORITES]: ColorClasses.ORANGE,
    [ProjectStatuses.MINE]: ColorClasses.EMPTY,
  };

  get status(): string {
    return this.multipleSelect ? this.currentStatuses.join(', ') : this.currentStatus;
  }

  @HostListener('document:mouseup', ['$event.target'])
  documentMouseDown(target: HTMLElement) {
    if (!this.elementRef.nativeElement.contains(target)) {
      this.showItems = false;
    }
  }

  toggle(e: any) {
    e.stopPropagation();
    this.showItems = !this.showItems;
  }

  handleClick(e: any, status: string): void {
    e.stopPropagation();

    if (!this.multipleSelect) {
      this.filter.emit(status);
      return;
    }

    // handle multipleSelect
    const isStatusAlreadyActive = this.isStatusActive(status);
    const statuses = isStatusAlreadyActive
      ? this.currentStatuses.filter(s => s !== status)
      : [...this.currentStatuses, status];

    if (this.currentStatuses.includes(ProjectStatuses.ALL)) {
      this.filterMultiple.emit([status]);
      return;
    }

    if (
      status === ProjectStatuses.ALL ||
      statuses.length === this.statusesArray.length - 1
    ) {
      this.filterMultiple.emit([ProjectStatuses.ALL]);
      return;
    }

    this.filterMultiple.emit(statuses.length > 0 ? statuses : [ProjectStatuses.ALL]);
  }

  getFilterColorClass(status: ProjectStatuses): ColorClasses {
    if (this.label === AvailableLabelsWithColoredFilter.Projects) {
      return this.statusColors[status];
    }
    // @ts-expect-error
    return null;
  }

  canAddColoredFilter(): boolean {
    // @ts-expect-error
    return !!AvailableLabelsWithColoredFilter[this.label];
  }

  isStatusActive(status: string): boolean {
    return this.multipleSelect
      ? this.currentStatuses.includes(status)
      : this.currentStatus === status;
  }

  get statusLabelForTotals(): string {
    const getStatusLabel = (status: string) =>
      (this.statusLabelsArray && this.statusLabelsArray[status]) ||
      StringUtils.titleCase(status);

    if (this.multipleSelect) {
      return this.currentStatuses.map(getStatusLabel).join(', ');
    }

    return getStatusLabel(this.currentStatus);
  }

  constructor(
    private elementRef: ElementRef,
    readonly cdr: ChangeDetectorRef,
    readonly store$: Store<State>,
  ) {
    super();
  }
}
